import {
  DROPDOWN_OPTIONS_RESET,
  DROPDOWN_OPTIONS_UPDATE
} from 'constants/actionTypes';

export const dropdownOptionsAction = {
  updateDropdownOptions
};

function updateDropdownOptions(action: string, data: any, key: string) {
  return async (dispatch: any) => {
    if (action === DROPDOWN_OPTIONS_UPDATE) {
      dispatch({
        type: DROPDOWN_OPTIONS_UPDATE,
        payload: {[key]: data}
      });
    } else if (action === DROPDOWN_OPTIONS_RESET) {
      dispatch({
        type: DROPDOWN_OPTIONS_RESET
      });
    } else {
      console.error('Invalid action type for dropdown options update');
    }
  };
}
